"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardAppearanceOption')(function discardAppearanceOption(state) {
    var optionState = state.optionState;
    optionState.weekStartDay = null;
}));
//# sourceMappingURL=discardAppearanceOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-calendar-appearance-option/lib/actions/discardAppearanceOption.js
// module id = 5260
// module chunks = 2